import { Component, OnInit } from '@angular/core';
import { TemplatesService } from '../templates.service';
import { TemplateInterface } from 'models/template.model';
import { Property } from 'models/property.model';
import { AuthService } from '../shared/services/auth.service';
import { PropertiesService } from '../properties.service';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import Inputmask from "inputmask";
declare var $: any;

@Component({
  selector: 'app-new-property',
  templateUrl: './new-property.component.html',
  styleUrls: ['./new-property.component.scss']
})
export class NewPropertyComponent implements OnInit {
  public selectedTemplate: TemplateInterface;
  public newProperty: Property;

  public highlightFields: boolean = false;
  public creatingProperty: boolean = false;

  public errorCreatingPropertyMsg: string = '';

  public cleanHost: string = "";
  public dirtyHost: string = "";
  public domainResponse: string = "";
  public domainResponseCode: number = 0;
  public purchaseDomainFlag: boolean;
  ownDomainFlag: boolean;



  selectTemplate(template: TemplateInterface) {
    if (this.selectedTemplate && this.selectedTemplate.previewUrl === template.previewUrl) {
      this.selectedTemplate = null;
    } else {
      this.selectedTemplate = template;
      this.updateProperty();
    }
  }

  updateProperty() {
    console.log(this.auth.userData);
    if (!this.auth.userData) return;
    this.newProperty = new Property({
      _client_id: this.auth.userData.uid,
      _id: new Date().getTime().toString(),
      clean_template_id: 1,
      clean_template_public: this.selectedTemplate ? this.selectedTemplate._id : '',
      configuration: {
        _id: new Date().getTime().toString(),
        _property_id: '',
        configuration: {
          allowedBrowerHeaders: [],
          allowedCountries: [],
          blockedCities: [],
          blockedPostalCodes: [],
          allowedISPs: [],
          allowedTimezones: [],
          allowedUserAgents: [],
          blockedBrowerHeaders: [],
          blockedCountries: [],
          blockedISPs: [],
          blockedTimezones: [],
          blockedUserAgents: [],
          urlContains: ''
        },
        options: {
          deadbolt: "on",
          facebook: "on"
        }
      },
      dirty_url: this.dirtyHost,
      hostname: this.cleanHost,
      icon: 'feather',
      name: this.cleanHost,
      redirect: true,
      redirect_url: this.sanitizeDirtyUrl(this.dirtyHost),
      template: this.selectedTemplate,
      title: this.dirtyHost
    });

    this.properties.currentProperty = this.newProperty;

    console.log(`New Property: `, this.newProperty);

    this.properties.getURLMetadata(this.dirtyHost);
  }

  constructor(private router: Router, public templateService: TemplatesService, private auth: AuthService, private properties: PropertiesService) {
    console.log(this.auth.userData);
    if (!this.auth.userData) return;

    this.newProperty = new Property({
      _client_id: this.auth.userData.uid,
      _id: new Date().getTime().toString(),
      clean_template_id: -1,
      clean_template_public: 'lawncare',
      configuration: {
        _id: new Date().getTime().toString(),
        _property_id: '',
        configuration: {
          allowedBrowerHeaders: [],
          allowedCountries: [],
          blockedCities: [],
          blockedPostalCodes: [],
          allowedISPs: [],
          allowedTimezones: [],
          allowedUserAgents: [],
          blockedBrowerHeaders: [],
          blockedCountries: [],
          blockedISPs: [],
          blockedTimezones: [],
          blockedUserAgents: [],
          urlContains: ''
        },
        options: {
          deadbolt: "on",
          facebook: "on"
        }
      },
      dirty_url: '',
      hostname: '',
      icon: 'feather',
      name: '',
      redirect: true,
      redirect_url: '',
      template: {
        _id: new Date().getTime().toString(),
        description: '',
        footer: '',
        head: '',
        html: '',
        previewUrl: '',
        price: -1,
        screenshotUrl: '',
        title: '',
        pixelCode: '',
        trackingCodes: '',
        creative: {
          headline: '',
          subheadline: '',
          image: '',
          link: '',
          description: ''
        }
      },
      title: ''
    });
  }

  confirmRegister() {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this! This will permanently use one of your available domains. ",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, register it!'
    }).then((result) => {

      if (result.value) {

        this.properties.registerDomain(this.cleanHost, this.auth.userData.uid).then((success: boolean) => {
          if (success) {
            Swal.fire(
              'Registered!',
              `You are the proud new owner of ${this.cleanHost}!`,
              'success'
            );
          } else {
            Swal.fire(
              'Failed to register!',
              `We couldn't register ${this.cleanHost} on your behalf, apologies!`,
              'warning'
            );
          }

        });


      }
    });
  }

  sanitizeDirtyUrl = (url: string): string => {
    let returnValue: string = '';

    //Check if we have http://, or https://
    if (url.startsWith('http://') || url.startsWith('https://')) {
      //Fuck it, ship it 
      returnValue = url;
    } else {
      returnValue = 'http://' + url;
    }

    return returnValue;
  }

  checkDomain() {
    if (!this.cleanHost) return;
    if (this.cleanHost && this.cleanHost.length < 5) return;
    this.properties.checkDomain(this.cleanHost).then((reply: boolean) => {
      if (reply) {
        this.domainResponse = this.cleanHost + " is available!";
        this.domainResponseCode = 1;
      } else {
        this.domainResponse = "Sorry but " + this.cleanHost + " isn't available";
        this.domainResponseCode = 2;
      }
    })
  }

  disableOwnedDomain() {
    this.ownDomainFlag = false;
    this.highlightFields = false;
  }

  disablePurchaseDomain() {
    this.purchaseDomainFlag = false;
    this.highlightFields = false;
  }

  ngOnInit() {
    let that = this;
    $("#wizard").steps({
      headerTag: "h2",
      bodyTag: "section",
      transitionEffect: "slideLeft",
      onStepChanging: function (event, currentIndex, newIndex) {
        switch (currentIndex) {
          case 0:
            if (!that.dirtyHost) {
              that.highlightFields = true;
            } else {
              that.highlightFields = false;
            }
            return that.dirtyHost;

          case 1:
            if (!that.cleanHost) {
              that.highlightFields = true;
            } else {
              that.highlightFields = false;
            }
            return that.cleanHost;

          case 2:
            return that.selectedTemplate;

          case 3:
            return true;
        }


        console.log(`onStepChanging ${event} ${currentIndex} ${that.cleanHost && that.dirtyHost}`, that.cleanHost);
        return true;
      },
      onFinishing: function (event, currentIndex) {
        console.log(`onStepChanging ${event} ${currentIndex}`);
        return true;
      },
      onFinished: function (event, currentIndex) {
        that.creatingProperty = true;

        Swal.fire({
          title: 'Are you sure?',
          text: "You will be able to use your new cloaked domain immediately, this will consume one of your available properties.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, create it!'
        }).then((result) => {
    
          if (result.value) {
    
            that.properties.createProperty(that.auth.userData.uid, that.newProperty).then((reply: boolean) => {
              that.creatingProperty = false;
              
              Swal.fire(
                `You're All Set!`,
                `Let's customize your template for ${that.cleanHost}!`,
                'success'
              );

                //We need to dns record check the cleanhost and navigate appropiately 
              that.router.navigate(['edit_template']);
    
            });
          }
        });
      }
    });
  }
}
